import React from 'react';
import { FormInputProps } from 'semantic-ui-react';

import PrimaryButton from '@modules/common/components/buttons/PrimaryButton';
import { styled } from '@modules/common/components/ThemeProvider/utils';
import SecondaryButton from '@modules/common/components/buttons/SecondaryButton';
import FormInputField from '@modules/common/components/Field/FormInputField';

import { EMPTY_ORIGIN, allOriginsAllowed, isAllowedOriginSet } from '../../utils';

type Props = {
  allowedOriginDomains?: string[];
  setAllowedOriginDomains: (origins?: string[]) => void;
};

function AllowedOriginsSelection({ allowedOriginDomains = [''], setAllowedOriginDomains }: Props) {
  function onAddNewOrigin() {
    if (allowedOriginDomains) {
      setAllowedOriginDomains([...allowedOriginDomains, EMPTY_ORIGIN]);
    }
  }

  function onRemoveOrigin(index: number) {
    if (allowedOriginDomains.length === 1) {
      setAllowedOriginDomains([EMPTY_ORIGIN]);
    } else {
      const newAllowedOrigins = [...allowedOriginDomains];
      newAllowedOrigins.splice(index, 1);
      setAllowedOriginDomains(newAllowedOrigins);
    }
  }

  function updateAllowedOrigin(index: number, value: string) {
    const updatedAllowedOrigins = [...allowedOriginDomains];
    updatedAllowedOrigins[index] = value;
    setAllowedOriginDomains(updatedAllowedOrigins);
  }

  if (allOriginsAllowed(allowedOriginDomains)) {
    return null;
  }

  return (
    <StyledDomainInputWrapper>
      {allowedOriginDomains.map((origin, index) => {
        return (
          <StyledDomainTextInputWrapper>
            <StyledFormInput
              value={origin}
              placeholder="Enter allowed web origin"
              onChange={(_: any, { value }: FormInputProps) => updateAllowedOrigin(index, value)}
              disabled={allOriginsAllowed(allowedOriginDomains)}
              fieldName="origin"
              focus
            />
            {isAllowedOriginSet(allowedOriginDomains) && (
              <SecondaryButton
                icon="minus"
                onClick={() => onRemoveOrigin(index)}
                disabled={origin === EMPTY_ORIGIN && allowedOriginDomains.length === 1}
              />
            )}
            {index === allowedOriginDomains.length - 1 && (
              <StyledAddButton
                icon="plus"
                onClick={onAddNewOrigin}
                disabled={origin === EMPTY_ORIGIN}
              />
            )}
          </StyledDomainTextInputWrapper>
        );
      })}
    </StyledDomainInputWrapper>
  );
}

export default AllowedOriginsSelection;

const StyledDomainInputWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
`;

const StyledDomainTextInputWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  flex: 3;

  .field {
    width: 75%;
  }
`;

const StyledAddButton = styled(PrimaryButton)``;

const StyledFormInput = styled(FormInputField)`
  margin-bottom: 0 !important;
`;
